import TIK from 'constants/time/timeIntervalKind.const';
import { fromAnyDateToDate, fromAnyDateToIso, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import expandDateRangeLimits from 'utils/predicates/time/expandDateRangeLimits.util';

const L = logger('createTimeInterval'); // eslint-disable-line no-unused-vars

const createTimeInterval = (options) => {
  const { now: raw, kind, custom, parseFailTo } = options ?? {};

  // in case now is used in two places, it is good to have the same value in both
  const parsed = fromAnyDateToIso(raw) || fromAnyDateToIso(parseFailTo);
  const expanded = TIK.custom === kind ? custom : expandDateRangeLimits({ kind, raw, date: parsed });

  const bgnIso = custom ? fromAnyDateToIso(expanded?.bgn) : fromAnyDateToIso(expanded?.bgn) || parsed;
  const endIso = custom ? fromAnyDateToIso(expanded?.end) : fromAnyDateToIso(expanded?.end) || parsed;

  const bgnZulu = fromAnyDateToZulu(bgnIso);
  const endZulu = fromAnyDateToZulu(endIso);

  const bgnDate = bgnIso ? fromAnyDateToDate(bgnIso) : new Date(NaN);
  const endDate = endIso ? fromAnyDateToDate(endIso) : new Date(NaN);

  const bgnTimestamp = bgnDate.getTime();
  const endTimestamp = endDate.getTime();

  return { kind, raw, bgnDate, endDate, bgnIso, endIso, bgnZulu, endZulu, bgnTimestamp, endTimestamp };
};

export default createTimeInterval;
